import React from 'react';

import { GunIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../types';

type WeaponEvent = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    overview?: AnalyticDetailsEvent['event']['overview'] & {
      detection?: Record<string, unknown>;
    };
    weapon_score?: number;
  };
};

export function WeaponDetails({ event }: { event: WeaponEvent }): React.JSX.Element {
  const { t } = useTranslation();
  const score = calculateProbabilityPercent(event.event.weapon_score);
  const detection = event.event.overview?.detection;

  return (
    <BaseVideoAnalyticsDetails
      detections={detection ? [detection] : []}
      detectionType="bbox"
      event={event}
      tags={(
        <Tag
          data-testid="workspace.analyticEventDetails.extraTagType"
          icon={<GunIcon />}
          kind="neutral"
          size="large"
          value={`${t('videoAnalytics:weaponAnalyticDetails.workspace.tag.label')} ${score}%`}
        />
      )}
      title={t('videoAnalytics:weaponAnalyticDetails.workspace.title')}
    />
  );
}
